/**
 * AdminV2JobsMap — wraps the existing AdminJobsMap component (heavy Google Maps
 * integration with markers, heatmap, geocoding) inside the V2 layout shell.
 * The map widget itself stays unchanged. CSS overrides via .pv2-legacy-skin
 * flip the legacy Tailwind colors to V2 dark editorial palette.
 */
import React from 'react';
import PortalV2Layout from './PortalV2Layout';
import AdminJobsMap from '../portal/AdminJobsMap';

const AdminV2JobsMap = () => (
  <PortalV2Layout
    eyebrow="Geospatial"
    title="Jobs Map"
    subtitle="Live geocoded view of every active job — filter by status, client, or date range."
    crumbs={<><span style={{ opacity: 0.5 }}>Admin /</span> <strong style={{ marginLeft: 6 }}>Map</strong></>}
  >
    <div className="pv2-legacy-skin" style={{ background: 'var(--pv2-ink)', border: '1px solid var(--pv2-ink-line)', overflow: 'hidden' }} data-testid="pv2-jobs-map-wrap">
      <AdminJobsMap embedded />
    </div>
  </PortalV2Layout>
);

export default AdminV2JobsMap;
